import './envVars'; // Must always be first import!
import './prepareILIAS';
import {Slide} from '@mui/material';
import {FeatureToggleModal, renderReact} from '@zs21/drv-bund-common-ilias-utils';
import {SnackbarProvider} from 'notistack';
import React from 'react';
import './index.css';
import {CourseSearchModal} from './CourseSearch/CourseSearchModal';
import {withFeatureToggleProvider} from './featureToggleConfig';
import GlobalFeedback from './Feedback/GlobalFeedback';
import ReportProblemModal from './ReportProblem/ReportProblemModal';
import {CreateExternalReferentAccountModal} from './UserImport/CreateExternalReferentAccountModal';
import UserImportDialog from './UserImport/UserImportDialog';
import Voucher from './Voucher/Voucher';
import CourseDataDisplay from './CourseDataDisplay/CourseDataDisplay';

const render = (id, children) => {
    renderReact(
        document.getElementById(id),
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            domRoot={document.getElementsByTagName('body')[0]}
            TransitionComponent={Slide}
        >
            {children}
        </SnackbarProvider>,
        {sx: {background: 'transparent'}},
    );
};

render('feedback-root', <GlobalFeedback/>);
render('course-info-root', withFeatureToggleProvider(<>
    <CourseDataDisplay />
</>));
render('voucher-root', withFeatureToggleProvider(<>
    <Voucher/>
    <ReportProblemModal/>
    <UserImportDialog/>
    <CreateExternalReferentAccountModal/>
    <CourseSearchModal/>
</>));
render('feature-toggle-modal', withFeatureToggleProvider(<>
    <FeatureToggleModal/>
</>));
